import { useState, useRef, useEffect } from 'react';

const ROLE_OPTIONS = ["All", "CP", "CM", "SP", "SM"];
const STATUS_OPTIONS = ["All", "To be reassigned", "Draft change needs review", "Draft change accepted", "Draft change rejected", "Elective reassignment", "Excel Import Reassignment"];

export default function MiniFilterBar({ value, onChange }) {
  const [localQ, setLocalQ] = useState(value.q || '');
  const timerRef = useRef(null);

  // Sync if parent resets q externally (e.g., clear filters)
  useEffect(() => { setLocalQ(value.q || ''); }, [value.q]);

  const onQ = (e) => {
    const v = e.target.value;
    setLocalQ(v);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onChange({ ...value, q: v }), 200);
  };
  const onRole = (e) => onChange({ ...value, role: e.target.value });
  const onStatus = (e) => onChange({ ...value, status: e.target.value });

  return (
    <section className="ab-filterbar ab-filterbar--mini" aria-label="Draft filters">
      <div className="fb-row">
        <div className="fb-field fb-search">
          <label>Search</label>
          <input
            className="ab-input"
            placeholder="Search client or staff…"
            value={localQ}
            onChange={onQ}
          />
        </div>

        <div className="fb-field">
          <label>Role</label>
          <select
            className="ab-select"
            value={value.role}
            onChange={onRole}
          >
            {ROLE_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
          </select>
        </div>

        <div className="fb-field">
          <label>Status</label>
          <select
            className="ab-select"
            value={value.status}
            onChange={onStatus}
          >
            {STATUS_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
          </select>
        </div>
      </div>
    </section>
  );
}
